__turbopack_context__.v({
  "className": "fcQ5Sa_className",
  "variable": "fcQ5Sa_variable",
});
